import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import WebFont from 'webfontloader'
import * as serviceWorker from './serviceWorker';
import './dx.common.scss';
import './dx.light.scss';
import './dx.material.otc-theme.css';
import { BrowserRouter } from 'react-router-dom';

// load OTC fonts
WebFont.load({
  google: {
    families: [
      'Nunito Sans:200,200i,400,400i,600,600i,700,700i,900,900i',
      'Source Serif Pro:400,700'
    ]
  }
})

const rootElement = document.getElementById('root');

const root = ReactDOM.createRoot(rootElement);


root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
